import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import BottomNavigationMap from 'components/BottomNavigation/BottomNavigationMap';

/**
 * This component is a placeholder for the BottomNavigationMap component to be able to link it via Contentful.
 */
export function BottomNavigationMapLink() {
  return (
    <>
      <Box
        sx={{
          pb: 2,
        }}
      >
        <Divider />
      </Box>
      <BottomNavigationMap />
    </>
  );
}
